<svelte:options accessors />
<script>
  import { createEventDispatcher, onMount } from "svelte";
  /**@type {HTMLDialogElement}*/
  let modal;
  const dispatch = createEventDispatcher();
  /**@type {boolean}*/
  export let isOpen = false;
  
  export function showModal() {
    isOpen = true;
    modal.showModal();
    bodyScroll.prevent();
  }
  export function close() {
    modal.close();
  }

  // @ts-ignore
  const bodyScroll = {
    prevent() {
      // @ts-ignore
      document.querySelector("body").style.overflow = "hidden";
    },
    allow() {
      // @ts-ignore
      document.querySelector("body").style.overflow = null;
    },
  };

  onMount(() => {
    modal.addEventListener(
      "close",
      () => {
        bodyScroll.allow();
        isOpen = false;
        dispatch("close");
      },
      false
    );

    return () => {
      modal.removeEventListener(
        "close",
        () => {
          bodyScroll.allow();
          isOpen = false;
        },
        false
      );
    };
  });
</script>

<dialog bind:this={modal}>
  <div class="wrapper">
    <slot />
  </div>
  <button class="close" on:click={close} aria-labelledby="close">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.456"
      height="25.456"
      viewBox="0 0 25.456 25.456"
    >
      <path
        d="M18.344,28.111V19.878H10.111V18.344h8.233V10.111h1.533v8.233h8.233v1.533H19.878v8.233Z"
        transform="translate(12.728 -14.299) rotate(45)"
        fill="#191919"
      />
   
    </svg>
  </button>
</dialog>

<style>

  button {
    border: none;
    background: transparent;
    cursor: pointer;
  }

  dialog {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 82px clamp(10px, 10%, 100px);
    border: none;
    width: clamp(0px, 100vw, 528px);
    max-inline-size: min(90vw, 528px);
    max-block-size: min(80vh, 100%);
    max-block-size: min(80dvb, 100%);
    overflow: hidden;
    border-radius: 30px;
  }

  dialog[open] {
    display: flex;
  }

  dialog::backdrop {
    background: rgba(0, 0, 0, 0.63);
    background-position-y: 80px;
  }

  button.close {
    position: absolute;
    top: 30px;
    right: 30px;
  }

  .wrapper {
    overflow-y: scroll;
    padding-right: 16px;
  }
</style>
